import { Component, OnInit } from "@angular/core";
import { AppService } from "../../services/app.service";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-resetpassword",
  templateUrl: "./resetpassword.component.html",
})
export class ResetpasswordComponent implements OnInit {
  resetForm: FormGroup;
  path: any;
  errorMsg = false;
  submitDisable = false;
  errorMsgData: any;
  passwordSubmitted: boolean;
  newPassword: any;
  confirmPassword: any;
  passwordMismatch = false;
  selectedlang: any = [];
  selectedEmail: any;
  cfpasswordview: any = "password";
  newpasswordview: any = "password";
  constructor(
    private appService: AppService,
    private router: Router,
    private linkBuilder: FormBuilder
  ) {
    this.resetForm = this.linkBuilder.group({
      newPassword: [
        "",
        [Validators.required, Validators.pattern(environment.passwordPattern)],
      ],
      confirmPassword: ["", Validators.required],
    });
    this.selectedEmail = "";
  }

  ngOnInit() {
    this.appService.getlang().subscribe((res) => {
      if (res && res["resetPage"]) {
        this.selectedlang = res["resetPage"];
      }
    });
    this.checkLink();
  }

  checkLink() {
    this.path = this.router.url;
    if (this.path.indexOf("?") > -1) {
      const Splitpath = this.path.split("?");
      const link = Splitpath[1];
      const link1 = link.split("=");
      const value = {
        vurl: link1[1],
      };
      this.appService.checkLink(value).subscribe(
        (res) => {
          if (res && res["status"]["status"] === 200) {
            this.errorMsg = false;
            this.submitDisable = false;
            this.selectedEmail = res["entity"]["email"];
          }
          this.handleResetLinkStatus(res);
        },
        (err) => {
          this.handleResetLinkError();
        }
      );
    } else {
      this.handleResetLinkMissing();
    }
  }

  private handleResetLinkStatus(res) {
    if (res && res["status"]["status"] === 302) {
      this.errorMsg = true;
      this.submitDisable = true;
      this.errorMsgData = this.selectedlang.expired;
      setTimeout(() => {
        this.errorMsg = false;
        this.router.navigate(["/login"]);
      }, 5000);
    }
    if (res && res["status"]["status"] === 229) {
      this.errorMsg = true;
      this.errorMsgData = this.selectedlang.notmatched;
      setTimeout(() => {
        this.errorMsg = false;
        this.router.navigate(["/login"]);
      }, 5000);
    }
    if (res && res["status"]["status"] === 204) {
      this.submitDisable = true;
      this.errorMsg = true;
      this.errorMsgData = this.selectedlang.verification;
      setTimeout(() => {
        this.errorMsg = false;
        this.router.navigate(["/login"]);
      }, 5000);
    }
  }

  private handleResetLinkError() {
    this.errorMsg = true;
    this.errorMsgData = this.selectedlang.missingfields;
    setTimeout(() => {
      this.errorMsg = false;
    }, 8000);
  }

  private handleResetLinkMissing() {
    this.errorMsg = true;
    this.submitDisable = true;
    setTimeout(() => {
      this.errorMsgData = this.selectedlang.verification;
    }, 1000);
    setTimeout(() => {
      this.errorMsg = false;
    }, 5000);
  }

  Verification(resetObj) {
    this.path = this.router.url;
    if (this.path.indexOf("?") > -1) {
      const Splitpath = this.path.split("?");
      const link = Splitpath[1];
      const link1 = link.split("=");
      const value = {
        vurl: link1[1],
      };
      this.appService.verifyLink(value).subscribe(
        (res) => {
          if (res && res["status"]["status"] === 200) {
            this.errorMsg = false;
            this.submitDisable = false;
            this.selectedEmail = res["entity"]["email"];
            if(resetObj){
              this.resetObj(resetObj);
            }
          }
          this.handleResetLinkStatus(res);
        },
        (err) => {
          this.handleResetLinkError();
        }
      );
    } else {
      this.handleResetLinkMissing();
    }
  }

  resetObj(value){
    this.appService.resetPassword(value).subscribe(
      (res) => {
        if (res && res["status"]["status"] === 200) {
          this.errorMsg = false;
          this.resetForm.reset();
          this.router.navigate(["/login"]);
        }
        if (res && res["status"]["status"] === 204) {
          this.errorMsg = true;
          this.errorMsgData = this.selectedlang.userNotFound;
          setTimeout(() => {
            this.errorMsg = false;
          }, 5000);
        }
      },
      (err) => {
        this.errorMsg = true;
        this.errorMsgData = this.selectedlang.wrong;
        setTimeout(() => {
          this.errorMsg = false;
        }, 5000);
      }
    );
  }

  ResetPassword(data) {
    this.errorMsg = false;
    this.passwordSubmitted = true;
    if (data.valid) {
      this.newPassword = this.resetForm.value.newPassword;
      this.confirmPassword = this.resetForm.value.confirmPassword;
      if (this.newPassword && this.confirmPassword) {
        if (this.newPassword !== this.confirmPassword) {
          this.passwordMismatch = true;
          this.errorMsg = true;
          this.errorMsgData = this.selectedlang.mismatch;
          setTimeout(() => {
            this.errorMsg = false;
          }, 5000);
        } else {
          this.errorMsg = false;
          this.passwordMismatch = false;
          this.passwordSubmitted = false;
          const value = {
            userName: this.selectedEmail,
            password: this.resetForm.value.newPassword,
            confirmPassword: this.resetForm.value.confirmPassword,
          };
          
          this.Verification(value);
        }
      }
    } else {
      if (
        ((data.get("newPassword").errors &&
          data.get("newPassword").errors.required) ||
          data.get("newPassword").touched) &&
        ((data.get("confirmPassword").errors &&
          data.get("confirmPassword").errors.required) ||
          data.get("confirmPassword").touched)
      ) {
        this.errorMsg = true;
        this.errorMsgData = this.selectedlang.missingfields;
        setTimeout(() => {
          this.errorMsg = false;
        }, 5000);
      }
      if (
        data.get("newPassword").errors &&
        data.get("newPassword").errors.pattern &&
        data.get("newPassword").touched
      ) {
        this.errorMsg = true;
        this.errorMsgData = this.selectedlang.passworsConstr;
        setTimeout(() => {
          this.errorMsg = false;
        }, 5000);
      }
    }
  }


  hidepassword(type) {
    if (type === "np") {
      this.newpasswordview = this.selectedlang.passwordviewtxt;
    }
    if (type === "cp") {
      this.cfpasswordview = this.selectedlang.passwordviewtxt;
    }
  }

  viewpassword(type) {
    if (type === "np") {
      this.newpasswordview = this.selectedlang.passwordviewtxt2;
    }
    if (type === "cp") {
      this.cfpasswordview = this.selectedlang.passwordviewtxt2;
    }
  }
}
